import React from "react";
import { getChangeLiveStatus, isLiveStatusFixed } from "../writingAssistantUtils";
import WritingPreviewFixedPopover from "./WritingPreviewFixedPopover";
import { useFixedPopover } from "./useFixedPopover";

export default function WritingPreviewChangeStatusBanner({
	latestValidation,
	changeIndex,
}) {
	const liveStatus = getChangeLiveStatus(latestValidation, changeIndex);
	const { popoverProps, getHoverHandlers } = useFixedPopover();

	if (!liveStatus) return null;

	const isFixed = isLiveStatusFixed(liveStatus.status);
	const modifierClass = isFixed
		? "writing-preview__status-banner--fixed"
		: "writing-preview__status-banner--not-fixed";

	const hoverHandlers =
		liveStatus.explanation?.trim() ?
			getHoverHandlers({
				title: liveStatus.label,
				sections: [{ text: liveStatus.explanation }],
			})
		:	{};

	const handleMouseEnter = (event) => {
		event.stopPropagation();
		hoverHandlers.onMouseEnter?.(event);
	};

	const handleMouseLeave = (event) => {
		event.stopPropagation();
		hoverHandlers.onMouseLeave?.(event);
	};

	return (
		<>
			<div
				className={`writing-preview__status-banner ${modifierClass} ${
					liveStatus.explanation ? "writing-preview__status-banner--has-tooltip" : ""
				}`}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				{isFixed ? (
					<i className="fa-regular fa-circle-check me-1" />
				) : (
					<i className="fa-regular fa-circle-xmark me-1" />
				)}
				Live · {liveStatus.label}
			</div>
			<WritingPreviewFixedPopover {...popoverProps} />
		</>
	);
}
